import { config } from "../../../../app-confi/app-config";
import { columnType } from "./column-type.enum";

export interface MoosPlazaType {
    type: columnType,
    bays: number,
    uiName: string,
}

export const moosPlazaTypesModel: MoosPlazaType[] = [
    {
        type: columnType.none,
        bays: 0,
        uiName: 'Geen Entree'
    },
    {
        type: columnType.V_P32C_C_M,
        bays: 3,
        uiName: `Entree (${3 * config.corridorBaySize}m) + M app.`
    }, {
        type: columnType.V_P32C_2C_XS,
        bays: 3,
        uiName: `Entree (${3 * config.corridorBaySize}m) + XS app.`
    },
    {
        type: columnType.V_P3C_C_L,
        bays: 3,
        uiName: `Entree (${4 * config.corridorBaySize}m) + L app.`
    },
    {
        type: columnType.V_P4C_C_L_C_XS,
        bays: 4,
        uiName: `Entree (${4 * config.corridorBaySize}m) + L, XS app.`
    },
    {
        type: columnType.V_P42C_C_XS_C_M,
        bays: 4,
        uiName: `Entree (${4 * config.corridorBaySize}m) + XS, M app.`
    },
    {
        type: columnType.V_P42C_3C_XS,
        bays: 4,
        uiName: `Entree (${4 * config.corridorBaySize}m) + XS app.`
    },
    {
        type: columnType.V_P42C_C_XL,
        bays: 4,
        uiName: `Entree (${4 * config.corridorBaySize}m) + XL app.`
    },
    {
        type: columnType.V_P42_S1S2,
        bays: 4,
        uiName: `Entree (${4 * config.corridorBaySize}m) + S app.`
    },
    {
        type: columnType.V_P52C_4C_XS,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + S app.`
    },
    {
        type: columnType.V_P52C_C_XS_C_M,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + XS, M app.`
    },
    {
        type: columnType.V_P52C_2C_M,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + M app.`
    },
    {
        type: columnType.V_P5C_C_L_C_M,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + L, M app.`
    },
    {
        type: columnType.V_P5C_C_L_C_XS,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + L, XS app.`
    },
    {
        type: columnType.V_P52C_C_XS_2C_S,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + XS, S app.`
    },
    {
        type: columnType.V_P52C_C_XS_C_XL,
        bays: 5,
        uiName: `Entree (${5 * config.corridorBaySize}m) + XS, XL app.`
    }
]
